import React from "react";
import "./Ciclo.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import ciclo from "../../assets/img/projects/Ciclo full.png";
import { Link } from "react-router-dom";

function Ciclo() {
  return (
    <div className="ciclo">
      <Col xs={40} md={30}>
        <Row className="justify-content-center mb-5 mt-3 mr-0 ">
          <Image className="" alt="profile" src={ciclo} fluid />
        </Row>
      </Col>
      <Link to="/">
        <span className="button">BACK</span>
      </Link>
    </div>
  );
}

export default Ciclo;
